import {useMemo} from 'react';
import {useSelector} from 'react-redux';

// SELECTORS
import {
  isAltAccoSelector,
  roomInfoSelector,
  roomsDataSelector,
} from '@stencil/hotels-cg-reducer/src/details/selectors';

// UTILS
import {scrollToEl} from '@stencil/hotels-utils/src/scroll-into-view-details';
import {detailsNavigationIdsAndValues} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';

// COMPONENTS
import UGCCard, {UGCCardProps} from './UGCChipsCard';
import VillaDetailsCard from './VillaDetailsCard';
import {RightWidgetLoader} from '../../../../../../src/stories/components/hotels/Loadingpage/DetailCardLoader/DetailCardLoader';

// STYLES
import * as S from './styles/UGCCardChips.styles';

const AmenitiesAndServices: React.FC<UGCCardProps> = ({chips, onChipClick, type, isEntire}) => (
  <UGCCard
    heading="Amenities &amp; Services"
    chips={chips}
    onChipClick={onChipClick}
    type={type}
    isEntire={isEntire}
  />
);

const UGCCardChips: React.FC<{
  amenitiesData: string[];
}> = ({amenitiesData}) => {
  const entirePropData = useSelector(roomInfoSelector);
  const searchRoomData = useSelector(roomsDataSelector);
  const hasRoomsData = searchRoomData?.length > 0;
  const isAltAcco = useSelector(isAltAccoSelector);

  const onAmenityChipClick = () => {
    scrollToEl(detailsNavigationIdsAndValues.amenities.id);
  };

  const renderUGCPersuasions = useMemo(() => {
    if (!hasRoomsData) return <RightWidgetLoader />;
    const renderItem = [];
    if (isAltAcco) {
      renderItem.push(<VillaDetailsCard key={`UGCCHIP1`} entirePropertyData={entirePropData} />);
    }
    if (amenitiesData && amenitiesData.length) {
      renderItem.push(
        <S.UGCPersuasionsInnerWrap key={`UGCCHIP2`}>
          <AmenitiesAndServices
            heading="Amenities &amp; Services"
            chips={amenitiesData}
            onChipClick={onAmenityChipClick}
            type={'amenity'}
            isEntire={isAltAcco}
          />
        </S.UGCPersuasionsInnerWrap>,
      );
    }

    if (renderItem.length) {
      return (
        <S.UGCPersuasions>
          {renderItem.map(item => {
            return item;
          })}
        </S.UGCPersuasions>
      );
    } else {
      return null;
    }
  }, [hasRoomsData, amenitiesData, entirePropData]);

  return renderUGCPersuasions;
};

export default UGCCardChips;
